import React, { useEffect, useState } from "react";
import { Drawer, Spin, } from "antd";
import { ToastContainer, } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { useNavigate } from "react-router-dom";
// import { ExclamationCircleFilled } from "@ant-design/icons";
// import { cancelOrder } from "../../../api/AdminRequest";
// import SelectZeeqrCards from "../selectCard/SelectZeeqrCards";
import rotateimg from '../../assests/rotate.png';
import Moment from 'moment'
import SelectCardName from "../services/materailsDetail/SelectCardName";
import SelectBusinessQRCard from "../services/BusinessQRCard/SelectBusinessQRCard";
import SelectReviewCard from "../services/reviewQRCard/SelectReviewCard";
import { getMaterialDetails } from "../../api/AdminRequest";

// const { confirm } = Modal;
const digitalInterfaceImageUrl = "https://zeeqr2.s3.ap-south-1.amazonaws.com/DigitalThemes/theme-classic.png"


function OrderDrawer({ onClose, viewId, open, setChanges }) {
  // const navigate = useNavigate();
  const [drawerData, setDrawerData] = useState("");
  const [orderStatus, setOrderStatus] = useState("");
  const [loader, setLoader] = useState(true)
  // const [rotate, setRotate] = useState(false)
  const [cards, setCards] = useState([])
  const [rotate, setRotate] = useState(false)



  const [productDetails, setProductDetails] = useState({})

  useEffect(() => {
    const singleBookedCards = async () => {
      try {

        // console.log(viewId);
        setDrawerData(viewId);
        setOrderStatus(viewId.status)
        setCards(viewId?.card)

        const firstItem = viewId?.items?.[0];
        const cardType = viewId?.cardType || firstItem?.productType;

        if (cardType === 'reviewQRCard' || cardType === 'BusinessQRCard') {

          const { data } = await getMaterialDetails(viewId?.card?.productID?.materialID ? viewId?.card?.productID?.materialID : '654f1c404306d8f388ce5531');
          // console.log(data, '88888  ');
          if (data.success) {
            setProductDetails(data.materials)
          }
        }

        setLoader(false)
      } catch (error) {
        console.log(error);
      }
    };
    singleBookedCards();
  }, [viewId]);
  // console.log(cards, '||||||||||||||||||||||');
  console.log(drawerData, "drawerData");


  // const [isModalOpen, setIsModalOpen] = useState(false);

  // const showModal = () => {
  //   setIsModalOpen(true);
  // };
  // const [error, setError] = useState({});
  // const initialValues = { reason: '', comment: '' }

  // const [formValues, setFormValues] = useState(initialValues)

  // const handleChange = (e) => {
  //   const { name, value } = e.target
  //   setFormValues({ ...formValues, [name]: value })
  //   // console.log(formValues)
  // }
  // const handleOk = async () => {

  //   const id = drawerData._id
  //   try {
  //     const errors = validateForm(formValues)
  //     setError(errors)
  //     if (Object.keys(errors).length === 0) {
  //       setLoader(true)
  //       const { data } = await cancelOrder(id, formValues)
  //       console.log(data);
  //       if (data.success) {
  //         setIsModalOpen(false);
  //         setChanges(Date.now())
  //         setOrderStatus('cancelled')
  //         setLoader(false)
  //         toast.success('Order Cancelled Successfully', {
  //           position: "top-right",
  //           autoClose: 3000,
  //           hideProgressBar: false,
  //           closeOnClick: true,
  //           pauseOnHover: true,
  //           draggable: true,
  //           progress: undefined,
  //           theme: "dark",
  //         });

  //       }
  //     }
  //   } catch (error) {

  //   }
  // };
  // const validateForm = (data) => {
  //   const error = {};
  //   if (!data.reason) {
  //     error.reason = "full name required"
  //   }
  //   if (!data.comment) {
  //     error.comment = "company name required"
  //   }
  //   return error;
  // }
  // const handleCancel = () => {
  //   setIsModalOpen(false);
  // };

  // const showDeleteConfirm = () => {
  //   confirm({
  //     title: "Are you sure to cancel the order?",
  //     icon: <ExclamationCircleFilled />,
  //     content: "If you cancel now, you may not be able to avail this deal again.Do you still want to cancel ?",
  //     okText: "Cancel Order",
  //     okType: "danger",
  //     cancelText: "Back",
  //     onOk() {
  //       // handleDelete();
  //       setIsModalOpen(true);
  //     },
  //     onCancel() {
  //       console.log("Cancel");
  //     },
  //   });
  // };

  // const handleTrack = () => {

  // }

  // const Rotation = () => {
  //   setRotate(!rotate)
  // }
  // setInterval(()=>{
  //     Rotation()
  // },3000)

  // let materail = []
  // materail = drawerData?.card
  // console.log(materail, '??????????????????????');

  const orderItems = drawerData?.items?.length
    ? drawerData.items
    : drawerData?.card
      ? [drawerData?.card]
      : [];

  const Details = [
    { name: 'Full Name', data: drawerData.name },
    { name: 'Company Name', data: drawerData.companyName },
    { name: 'Status', data: orderStatus },
    { name: 'Email', data: drawerData.email },
    { name: 'Phone', data: drawerData.phone },
    { name: 'Order Date', data: Moment(drawerData.createdDate).format("Do MMM YYYY") },
    { name: 'Invoice ID', data: drawerData.invoiceID },
    { name: 'Address', data: drawerData.streetaddress },
    { name: 'Land Mark', data: drawerData.landmark },
    { name: 'Town/City', data: drawerData.towncity },
    { name: 'State', data: drawerData.state },
    { name: 'Country', data: drawerData.country },
    { name: 'Pincode', data: drawerData.postcode },
    { name: 'Order Note', data: drawerData.ordernote },
    { name: 'Coupon Code', data: drawerData?.couponCode ? drawerData?.couponCode : drawerData?.card?.couponCode },
  ]

  const orderInfo = [
    { name: 'Full Name', data: drawerData.name },
    { name: 'Company Name', data: drawerData.companyName },
    { name: 'Email', data: drawerData.email },
    { name: 'Phone', data: drawerData.phone },
    { name: 'Order ID', data: drawerData._id },
    { name: 'Invoice ID', data: drawerData.invoiceID },
    { name: 'Order Date', data: Moment(drawerData.createdDate).format("Do MMM YYYY") },
    { name: 'Order Status', data: orderStatus },
    { name: 'Tracking Number', data: drawerData.trackingNumber },
    { name: 'Carrier', data: drawerData.carrier },
  ]

  const formatPaise = (value) => {
    if (value === null || value === undefined || value === '') return value;
    const num = Number(value);
    return isNaN(num) ? value : String(num / 100);
  };

  const orderAmount = drawerData?.amount || formatPaise(drawerData.payment?.amount);

  const paymentCreatedAt = drawerData?.payment?.created_at
    ? Moment.unix(Number(drawerData?.payment?.created_at)).format("Do MMM YYYY, h:mm a")
    : drawerData?.payment?.updateDateTime
      ? Moment(drawerData?.payment?.updateDateTime).format("Do MMM YYYY, h:mm a")
      : '';

  const paymentDetails = [
    { name: 'Provider', data: drawerData.payment?.provider === 'stripe' ? 'Stripe' : drawerData.payment?.provider },
    { name: 'Status', data: drawerData.payment?.paymentStatus || (drawerData.payment?.provider === 'stripe' ? drawerData?.status : '') },
    { name: 'Amount', data: drawerData?.payment?.currency ? `${drawerData?.payment?.currency} ${orderAmount}` : orderAmount },
    { name: 'Amount Paid', data: formatPaise(drawerData.payment?.amount_paid) },
    { name: 'Amount Due', data: formatPaise(drawerData.payment?.amount_due) },
    { name: 'Attempts', data: drawerData.payment?.attempts },
    { name: 'Entity', data: drawerData.payment?.entity },
    { name: 'Order ID', data: drawerData.payment?.id },
    // { name: 'Payment Intent ID', data: drawerData.payment?.stripePaymentIntentId },
    // { name: 'Payment ID', data: drawerData.payment?.razorpay_payment_id },
    // { name: 'Signature', data: drawerData.payment?.razorpay_signature },
    { name: 'Receipt', data: drawerData.payment?.receipt },
    { name: 'Offer ID', data: drawerData.payment?.offer_id },
    { name: 'Created At', data: paymentCreatedAt },
    { name: 'Repayment', data: drawerData.payment?.repayment },
  ]

  const invoiceDetails = [
    { name: 'Invoice ID', data: drawerData.invoiceID },
    { name: 'Order ID', data: drawerData._id },
    { name: 'Receipt', data: drawerData.payment?.receipt },
    { name: 'Invoice Date', data: Moment(drawerData.createdDate).format("Do MMM YYYY") },
    { name: 'Amount', data: drawerData?.payment?.currency ? `${drawerData?.payment?.currency} ${orderAmount}` : orderAmount },
    { name: 'Payment Status', data: drawerData.payment?.paymentStatus },
    { name: 'Order Status', data: orderStatus },
  ]

  const paymentMethod = drawerData?.payment?.paymentMethod


  const cardDetails = {
    name: cards?.cardName,
    tagline: cards?.tagline
  }

  const Rotation = () => {
    setRotate(!rotate)
  }

  return (
    <div>
      <Drawer
        width={640}
        placement="right"
        closable={false}
        onClose={onClose}
        open={open}
      >
        <Spin spinning={loader}>
          <div className="flex justify-between">
            <p
              className="site-description-item-profile-p text-xl font-bold"
              style={{
                marginBottom: 24,
              }}
            >
              Details
            </p>


          </div>


          {/* <div className='grid grid-cols-2 gap-3 mt-3'>
            <div className="w-[350px] ml-2" >

              {drawerData?.cardType === 'reviewQRCard' ?
                <div className="flex justify-center">
                  <div className='h-[350px]  w-[222px] flex justify-center'>
                    <SelectReviewCard rotate={rotate} material={cards?.material} materialcolor={cards?.materialcolor} materialFavoriteColor={cards?.materialFavoriteColor} textColor={cards?.textColor} cardColor={cards?.cardColor} reviewType={cards?.reviewType} productDetails={productDetails} />
                  </div>
                </div>
                : drawerData?.cardType === 'BusinessQRCard' ?
                  <div className='w-[300px] sm:w-[350px]'>
                    <SelectBusinessQRCard rotate={rotate} material={cards?.material} materialcolor={cards?.materialcolor} materialFavoriteColor={cards?.materialFavoriteColor} textColor={cards?.textColor} cardColor={cards?.cardColor} productDetails={productDetails} />
                  </div>
                  :
                  <div className="h-52 w-32 overflow-hidden rounded-xl shadow-xl border-2">
                    <img src={cards?.productID ? cards?.productID?.imageUrl : digitalInterfaceImageUrl} alt="" srcset="" />
                  </div>
              }

              {drawerData?.cardType === 'reviewQRCard' || drawerData?.cardType === 'BusinessQRCard' ?
                <div className="flex justify-center item-center mt-5 mb-5">
                  <img className='cursor-pointer' src={rotateimg} onClick={Rotation} alt=''></img>
                </div>
                : ''
              }
            </div>
            {drawerData?.cardType === 'reviewQRCard' || drawerData?.cardType === 'BusinessQRCard' ?
              <div className=" flex flex-col w-60  justify-center ml-20">

                <p className='text-xl text-slate-600   font-bold '>{cards?.material}</p>
                <SelectCardName material={cards?.material} materialcolor={cards?.materialcolor} materialFavoriteColor={cards?.materialFavoriteColor} productDetails={productDetails} />

              </div>
              : ''
            }

          </div> */}


          <h1 className="text-lg font-bold mt-5">Order / Customer Info</h1>
          <div className="grid grid-cols-2 mt-2">
            {orderInfo.map((obj) => {
              return (
                <div className="mt-3" key={obj.name}>
                  {obj.data ?
                    <div className="flex ">
                      <p className="font-medium mr-2">{obj.name} : </p>
                      <p  > {obj.data}</p>
                    </div>
                    : ''
                  }
                </div>
              )
            })}
          </div>

          <h1 className="text-lg font-bold mt-5">Items ({orderItems.length})</h1>
          {orderItems.map((item, idx) => {
            const firstCard = item?.cards?.[0] || item;
            const pricing = item?.pricing;
            return (
              <div key={item?._id || idx} className="mt-3 border border-gray-200 rounded-lg p-4">
                <div className="flex items-start gap-4">
                  {firstCard?.cardLogo ?
                    <img src={firstCard.cardLogo} alt="card preview" className="w-16 h-10 rounded object-cover border" />
                    : item?.productID?.imageUrl ?
                      <img src={item.productID.imageUrl} alt="product" className="w-16 h-10 rounded object-cover border" />
                      : ''
                  }
                  <div className="flex-1 grid grid-cols-2 gap-x-6 gap-y-2">
                    <p className="text-sm"><span className="font-medium">Product: </span>{item?.productName || item?.cardName}</p>
                    <p className="text-sm"><span className="font-medium">Type: </span>{item?.productType}</p>
                    <p className="text-sm"><span className="font-medium">Material: </span>{item?.materialType || item?.material}</p>
                    <p className="text-sm"><span className="font-medium">Quantity: </span>{item?.quantity || 1}</p>
                    {item?.materialcolor ?
                      <p className="text-sm"><span className="font-medium">Material Color: </span>{item.materialcolor}</p>
                      : ''
                    }
                    {item?.materialFavoriteColor ?
                      <p className="text-sm"><span className="font-medium">Favorite Color: </span>{item.materialFavoriteColor}</p>
                      : ''
                    }
                    {item?.textColor ?
                      <p className="text-sm"><span className="font-medium">Text Color: </span>{item.textColor}</p>
                      : ''
                    }
                    {item?.cardColor ?
                      <p className="text-sm"><span className="font-medium">Card Color: </span>{item.cardColor}</p>
                      : ''
                    }
                    {item?.tagline ?
                      <p className="text-sm"><span className="font-medium">Tagline: </span>{item.tagline}</p>
                      : ''
                    }
                    {item?.status ?
                      <p className="text-sm"><span className="font-medium">Status: </span>{item.status}</p>
                      : ''
                    }
                  </div>
                </div>

                {pricing ?
                  <div className="mt-3 border-t pt-3">
                    <p className="text-sm font-semibold mb-1">Pricing</p>
                    <div className="grid grid-cols-2 gap-x-6 gap-y-1">
                      {pricing.retailPrice ?
                        <p className="text-sm"><span className="font-medium">Retail Price: </span>{pricing.retailPrice}</p>
                        : ''
                      }
                      {pricing.sellingPrice ?
                        <p className="text-sm"><span className="font-medium">Selling Price: </span>{pricing.sellingPrice}</p>
                        : ''
                      }
                      {pricing.discount ?
                        <p className="text-sm"><span className="font-medium">Discount: </span>{pricing.discount}</p>
                        : ''
                      }
                      {pricing.couponDiscount ?
                        <p className="text-sm"><span className="font-medium">Coupon Discount: </span>{pricing.couponDiscount}</p>
                        : ''
                      }
                      {pricing.vatAmount ?
                        <p className="text-sm"><span className="font-medium">VAT Amount: </span>{pricing.vatAmount}</p>
                        : ''
                      }
                      {pricing.total ?
                        <p className="text-sm font-semibold"><span className="font-medium">Total: </span>{pricing.total}</p>
                        : ''
                      }
                    </div>
                  </div>
                  : ''
                }

                {(item?.cards?.length && item.cards.length > 1) || item?.cards?.[0]?.name || item?.cards?.[0]?.status || item?.cards?.[0]?.cardID || item?.cards?.[0]?._id ?
                  <div className="mt-3 border-t pt-3">
                    <p className="text-sm font-semibold mb-1">Cards ({item.cards.length})</p>
                    {item.cards.map((card, i) => (
                      <div key={card?._id || card?.name || i} className="mt-2">
                        <div className="grid grid-cols-2 gap-x-6 gap-y-1">
                          {card?.name ?
                            <p className="text-sm"><span className="font-medium">Name: </span>{card.name}</p>
                            : ''
                          }
                          {card?.tagline ?
                            <p className="text-sm"><span className="font-medium">Tagline: </span>{card.tagline}</p>
                            : ''
                          }
                          {card?.status ?
                            <p className="text-sm"><span className="font-medium">Status: </span>{card.status}</p>
                            : ''
                          }
                          {card?.cardID || card?._id ?
                            <p className="text-sm break-all"><span className="font-medium">Card ID: </span>{card.cardID || card._id}</p>
                            : <p className="text-sm text-amber-500"><span className="font-medium">Card ID: </span>Cards not created</p>
                          }
                        </div>
                      </div>
                    ))}
                  </div>
                  : ''
                }
              </div>
            )
          })}

          <h1 className="text-lg font-bold mt-5">Shipping Details</h1>
          <div className="grid grid-cols-2 mt-2">
            {Details.map((obj) => {
              return (
                <div className="mt-3">
                  {obj.data ?
                    <div className="flex ">
                      <p className="font-medium mr-2">{obj.name} : </p>
                      <p  > {obj.data}</p>
                    </div>
                    : ''
                  }
                </div>
              )
            })}
          </div>

          <h1 className="text-lg font-bold mt-5">Payment Details</h1>
          {paymentDetails?.map((obj) => {
            return (
              <div className="mt-3" key={obj.name}>
                {obj.data ?
                  <div className="flex ">
                    <p className="font-medium mr-2">{obj.name} : </p>
                    <p  > {obj.data}</p>
                  </div>
                  : ''
                }
              </div>
            )
          })}


          {paymentMethod ?
            <>
              <h1 className="text-lg font-bold mt-5">Payment Method</h1>
              {Object?.keys(paymentMethod)?.map(key => (
                <div className="flex mt-3" key={key}>
                  <p className="capitalize font-medium mr-2"> {key} :</p>  <p> {paymentMethod[key]} </p>
                </div>
              ))
              }
            </>
            : ''
          }

          <h1 className="text-lg font-bold mt-5">Invoice</h1>
          <div className="grid grid-cols-2 mt-2">
            {invoiceDetails.map((obj) => {
              return (
                <div className="mt-3" key={obj.name}>
                  {obj.data ?
                    <div className="flex ">
                      <p className="font-medium mr-2">{obj.name} : </p>
                      <p  > {obj.data}</p>
                    </div>
                    : ''
                  }
                </div>
              )
            })}
          </div>




          {/* <Modal title="Confirm Cancel" confirmLoading={loader} open={isModalOpen} onOk={handleOk} onCancel={handleCancel}
            okText="Submit Request" cancelText="Back" closable={false} maskClosable={false}
          >
            <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
              <div className="col-span-full">
                <label htmlFor="usereasonrname" className="block text-sm font-medium leading-6 text-gray-900">
                  Reason
                </label>
                <div className="mt-2">
                  <input
                    type="text"
                    name="reason"
                    id="reason"
                    autoComplete="reason"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    placeholder=" reason for cancelling"
                    value={formValues.reason} onChange={handleChange}
                  />
                  <p className='text-red-500'>{error.reason}</p>
                </div>
              </div>

              <div className="col-span-full">
                <label htmlFor="about" className="block text-sm font-medium leading-6 text-gray-900">
                  Comment
                </label>
                <div className="mt-2">
                  <textarea
                    id="comment"
                    name="comment"
                    placeholder=" Write about why your are cancelling the product"
                    rows={3}
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    defaultValue={''}
                    value={formValues.comment} onChange={handleChange}
                  />
                  <p className='text-red-500'>{error.comment}</p>
                </div>
              </div>
            </div>
          </Modal> */}

        </Spin>
        <ToastContainer />
      </Drawer>

    </div>
  );
}

export default OrderDrawer;
